import {Assert} from "js-vextensions";
import * as THREE from "three";

export function ChangeMaterialsToSupportPainting(materials_raw: THREE.Material | THREE.Material[], textureRescaling = 1, createTexturesWhereMissing = false) {
	// Keep original textures as underlays
	const materials =
		Array.isArray(materials_raw) ? materials_raw :
		materials_raw != null ? [materials_raw] :
		[];

	for (const material of materials) {
		// Create paintable texture for each mesh
		const canvas = document.createElement("canvas");

		if (material instanceof THREE.MeshStandardMaterial || material instanceof THREE.MeshBasicMaterial || material instanceof THREE.MeshPhongMaterial) {
			//console.log("Mat:", material);
			const originalTexture = material.map;
			if (originalTexture) {
				const originalImage = originalTexture.image as HTMLImageElement;

				// if the image was already converted to a canvas (by a previous mesh/material sharing this texture), skip
				// (otherwise each additional mesh rescales it yet again, causing the canvas to shrink toward 0 width/height)
				if (originalImage instanceof HTMLCanvasElement) continue;
				if (originalImage) {
					Assert(originalImage.width > 0 && originalImage.height > 0, "Original texture image has invalid dimensions");
					canvas.width = originalImage.width * textureRescaling;
					canvas.height = originalImage.height * textureRescaling;
					const context = canvas.getContext("2d")! as CanvasRenderingContext2D;
					context.clearRect(0, 0, canvas.width, canvas.height);
					context.globalCompositeOperation = "source-over";
					context.drawImage(originalImage, 0, 0, canvas.width, canvas.height);

					originalTexture.image = canvas;
					originalTexture.needsUpdate = true; // Ensure the texture is updated
					material.needsUpdate = true;
				}
			} else if (createTexturesWhereMissing) {
				const texture = new THREE.CanvasTexture(canvas);

				// Set canvas size to 512x512 if no original texture
				canvas.width = 512;
				canvas.height = 512;
				const context = canvas.getContext("2d")! as CanvasRenderingContext2D;
				if (context) {
					context.fillStyle = "white";
					context.fillRect(0, 0, canvas.width, canvas.height);
				}

				texture.needsUpdate = true; // Ensure the texture is updated
				material.map = texture;
				material.needsUpdate = true;
			}
		}
	}
}